module.exports = __webpack_public_path__ + "assets/img/tab_img_sb.1afa656b.png";